import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ElTimePicker } from 'element-plus';
import IconTrashRed from '../icons/IconTrashRed.vue';
import IconClock from '../icons/IconClock.vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'TimeSelect',
  props: /*@__PURE__*/_mergeModels({
    size: { default: 'default' },
    disabled: { type: Boolean, default: false },
    addRemove: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["removeTimeSelect"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();

// Props


// Emits
const emit = __emit;

// Current value
const value = _useModel<string>(__props, "modelValue");

// Show different icon on hover
const timePicker = ref(null);
const isIconHovered = ref(false);

// Change icon to trash
const handleHover = (event: any) => {
    isIconHovered.value = !!event.target.closest('.el-input__prefix');
};

// Always remove the trash icon
const handleLeave = () => {
    isIconHovered.value = false;
};

// Remove the time select on click when hovering on icon
const handleClick = () => {
    if (isIconHovered.value) {
        emit('removeTimeSelect');
    }
};

// Disable midnight
const disabledMinutes = (hour: number) => {
  if (hour === 0) {
    return [0]
  }
}

// Add listeners on mounted
onMounted(() => {
    if (timePicker.value && __props.addRemove) {
        timePicker.value.addEventListener('mouseover', handleHover);
        timePicker.value.addEventListener('mouseleave', handleLeave);
        timePicker.value.addEventListener('click', handleClick);
    }
});

// Remove them on unmounted
onUnmounted(() => {
    if (timePicker.value && __props.addRemove) {
        timePicker.value.removeEventListener('mouseover', handleHover);
        timePicker.value.removeEventListener('mouseleave', handleLeave);
        timePicker.value.removeEventListener('click', handleClick);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "timePicker",
    ref: timePicker
  }, [
    _createVNode(_unref(ElTimePicker), {
      class: _normalizeClass([`time-picker size-${_ctx.size}`, _ctx.addRemove && 'has-remove']),
      placeholder: _unref($gettext)('Select time'),
      "popper-class": "time-picker-popper",
      format: "HH:mm",
      "value-format": "HH:mm",
      "disabled-minutes": disabledMinutes,
      clearable: false,
      editable: false,
      disabled: _ctx.disabled,
      "prefix-icon": isIconHovered.value ? IconTrashRed : IconClock,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
    }, null, 8, ["class", "placeholder", "disabled", "prefix-icon", "modelValue"])
  ], 512))
}
}

})